<div class="close-button pe-1">
  <button type="button" aria-label="Close" class="btn-close" (click)="closeModal()"></button>
</div>

<div class="modal-body">
  <app-escalated-ticket-summary #ticketSummaryComponent
                                [ticket]="ticket"
                                [grabFocus]="{focus: true, options: {preventScroll: true}}"
                                [canEditTicketAssignee]="true"
                                [showSiteName]="showSiteName"
                                [showSiteNameAsLink]="showSiteNameAsLink"
                                [showOtherEscalatedTicketsCount]="showOtherEscalatedTicketsCount"
                                [cardSummaryOnly]="false"
                                [readOnly]="readOnly"
                                (ticketOperation)="onTicketOperationFromSummaryComponent($event)"/>
  <app-escalated-ticket-body #ticketBodyComponent
                             [ticket]="ticket"
                             [showAttachmentId]="showAttachmentId"
                             [site]="site"
                             [addCommentConfig]="addCommentConfig"
                             [hideInboxControl]="hideInboxControl"
                             [showViewLinkedTicket]="showViewLinkedTicket"
                             [readOnly]="readOnly"
                             (attachmentPreviewUserAction)="onAttachmentPreviewUserAction($event)"
                             (ticketOperation)="onTicketOperationFromBodyComponent($event)"/>
</div>
